import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Video, Package, LogOut, PlusCircle, Coins } from "lucide-react";
import DroneIcon from "../components/DroneIcon";
import { useAuth } from "../lib/auth";

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const navItems = [
    { to: "/dashboard", icon: <LayoutDashboard size={18} />, label: "Panel", end: true },
    { to: "/dashboard/create", icon: <PlusCircle size={18} />, label: "Yeni Video" },
    { to: "/dashboard/videos", icon: <Video size={18} />, label: "Videolarım" },
    { to: "/dashboard/packages", icon: <Package size={18} />, label: "Paketler" },
  ];

  return (
    <div className="min-h-screen bg-[#020617] text-slate-100 flex">
      <aside className="hidden lg:flex w-64 flex-col border-r border-white/5 bg-slate-950/60 backdrop-blur-xl">
        <Link to="/" className="h-16 flex items-center gap-2 px-6 border-b border-white/5">
          <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#C29B62] to-[#7a5e34] flex items-center justify-center">
            <DroneIcon size={16} className="text-slate-950" />
          </div>
          <span className="font-display font-black tracking-tight">ProSanalDrone</span>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${isActive ? "bg-[#C29B62]/10 text-[#C29B62] border border-[#C29B62]/30" : "text-slate-300 hover:bg-white/5 hover:text-white border border-transparent"}`
              }>
              {item.icon} {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5 space-y-3">
          <div className="flex items-center gap-2 p-3 rounded-md bg-[#C29B62]/10 border border-[#C29B62]/30">
            <Coins size={18} className="text-[#C29B62]" />
            <div className="flex-1">
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Kredi</div>
              <div data-testid="sidebar-credits" className="font-display font-bold text-lg text-[#C29B62]">{user?.credits ?? 0}</div>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-300">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-xs font-bold">
                {user?.name?.[0] || user?.email?.[0]}
              </div>
            )}
            <div className="flex-1 min-w-0">
              <div data-testid="sidebar-name" className="truncate text-sm">{user?.name || "Kullanıcı"}</div>
              <div className="truncate text-xs text-slate-500">{user?.email}</div>
            </div>
            <button data-testid="logout-btn" onClick={handleLogout} className="p-2 rounded-md hover:bg-white/5 text-slate-400 hover:text-white">
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 border-b border-white/5 bg-slate-950/60 backdrop-blur-xl lg:hidden flex items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#C29B62] to-[#7a5e34] flex items-center justify-center">
              <DroneIcon size={16} className="text-slate-950" />
            </div>
            <span className="font-display font-black">ProSanalDrone</span>
          </Link>
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#C29B62]/10 border border-[#C29B62]/30">
            <Coins size={14} className="text-[#C29B62]" />
            <span className="text-[#C29B62] font-semibold text-sm">{user?.credits ?? 0}</span>
          </div>
        </header>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
